import { NAME } from './constants';
import { apiProvider } from './api';
import { router } from './router';

export const ZakaznikProdejce = {
	name: NAME,
	apiProvider,
	router,
};
